import { listeInventaires } from '@/api/gpao/stock'

/* Renvoi true si un inventaire est actuellement ouvert. */
export async function verifierInventaireOuvert(etablissementId) {
    let response = await listeInventaires(etablissementId)
    let inventaires = response.data
    return inventaires.find(i => i.valide === false) ? true : false
}